import classNames from 'classnames';
import { UserRound } from 'lucide-react';
import { InlineTextButton, Menu, MenuLabel, MenuContent, MenuItem, NamedLink } from '..';
import { FormattedMessage } from '../../util/reactIntl';

import css from './UserProfile.module.css';

const UserProfile = ({
  authenticatedOnClientSide,
  showCreateListingsLink,
  currentPage,
  onLogout,
  size,
}) => {
  return authenticatedOnClientSide ? (
    <Menu>
      <MenuLabel className={css.iconLink}>
        <div className={css.iconButton2} aria-label="Account">
          <UserRound className={css.icon} />
        </div>
      </MenuLabel>
      <MenuContent className={css.profileMenuContent}>
        {showCreateListingsLink
          ? [
              <MenuItem key="YourReviewsPage">
                <NamedLink
                  className={classNames(
                    css.menuLink,
                    currentPage === 'YourReviewsPage' ? css.currentPage : null
                  )}
                  name="YourReviewsPage"
                >
                  <span className={css.menuItemBorder} />
                  <FormattedMessage id="TopbarDesktop.yourReviewsLink" />
                </NamedLink>
              </MenuItem>,
              <MenuItem key="YourResalesPage">
                <NamedLink
                  className={classNames(
                    css.menuLink,
                    currentPage === 'YourResalesPage' ? css.currentPage : null
                  )}
                  name="YourResalesPage"
                >
                  <span className={css.menuItemBorder} />
                  <FormattedMessage id="TopbarDesktop.yourResalesLink" />
                </NamedLink>
              </MenuItem>,
            ]
          : null}
        <MenuItem key="ProfileSettingsPage">
          <NamedLink
            className={classNames(
              css.menuLink,
              currentPage === 'ProfileSettingsPage' ? css.currentPage : null
            )}
            name="ProfileSettingsPage"
          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.profileSettingsLink" />
          </NamedLink>
        </MenuItem>
        <MenuItem key="AccountSettingsPage">
          <NamedLink
            className={classNames(
              css.menuLink,
              currentPage === 'AccountSettingsPage' ? css.currentPage : null
            )}
            name="AccountSettingsPage"
          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.accountSettingsLink" />
          </NamedLink>
        </MenuItem>
        <MenuItem key="logout">
          <InlineTextButton rootClassName={css.logoutButton} onClick={onLogout}>
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.logout" />
          </InlineTextButton>
        </MenuItem>
      </MenuContent>
    </Menu>
  ) : (
    <NamedLink name="SignupPage" className={css.iconLink}>
      <button className={css.iconButton2} aria-label="Account">
        <UserRound className={css.icon} />
      </button>
    </NamedLink>
  );
};

export default UserProfile;
